var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 24 24",
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#e91e63"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m6.6 16.48 1.23 3.66c-1.77.57-2.99.94-3.08.93-.78-.03-1.54-.54-1.8-1.32-.33-1.02.21-2.12 1.23-2.46z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.31 13.58 1.24 3.69c-1.62.54-3.37 1.12-5.02 1.66l-1.23-3.68z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24 13.38c0 .82-.51 1.58-1.32 1.84 0 0-.96.32-2.44.81l-1.23-3.68 2.43-.81c1.02-.33 2.13.21 2.46 1.23.07.2.1.41.1.61z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m3.75 7.97 1.23 3.66c-1.77.57-2.99.94-3.08.93-.78-.03-1.54-.54-1.8-1.32-.33-1.02.2-2.12 1.23-2.46z",
    fill: "#00bcd4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m12.45 5.07 1.24 3.69c-1.61.54-3.36 1.12-5.01 1.66l-1.23-3.68z",
    fill: "#00bcd4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m19.81 6.72s-.95.32-2.42.81l-1.24-3.69 2.43-.81c1.02-.33 2.13.21 2.47 1.23.32 1.02-.21 2.13-1.24 2.46z",
    fill: "#00bcd4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m17.39 7.53c-1.03.34-2.31.77-3.7 1.23l-1.24-3.69 3.7-1.23z",
    fill: "#689f38"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m16.15 3.84-3.7 1.23-.84-2.51c-.32-1.03.21-2.13 1.23-2.46 1.03-.33 2.14.21 2.47 1.22z",
    fill: "#ffc107"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m20.24 16.03c-1.03.35-2.31.78-3.69 1.24l-1.24-3.69 3.7-1.23z",
    fill: "#b71c1c"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m19.01 12.35-3.7 1.23-1.62-4.82c1.39-.46 2.67-.89 3.7-1.23z",
    fill: "#ffc107"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m19.85 21c-1.14.33-2.14-.32-2.46-1.22l-.84-2.51c1.38-.46 2.66-.89 3.69-1.24l.84 2.51c.33 1.03-.2 2.13-1.23 2.46z",
    fill: "#ffc107"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m8.68 10.42c-1.35.44-2.63.86-3.7 1.21l-1.23-3.66 3.7-1.23z",
    fill: "#009688"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m7.45 6.74-3.7 1.23-.84-2.51c-.32-1.02.21-2.13 1.23-2.46 1.03-.33 2.14.21 2.47 1.23z",
    fill: "#4caf50"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m11.53 18.93c-1.35.44-2.62.86-3.7 1.21l-1.23-3.66 3.7-1.23z",
    fill: "#880e4f"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m10.3 15.25-3.7 1.23-1.62-4.85c1.07-.35 2.35-.77 3.7-1.21z",
    fill: "#4caf50"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m11.14 23.91c-1.14.33-2.14-.32-2.46-1.22l-.85-2.55c1.08-.35 2.35-.77 3.7-1.21l.84 2.52c.33 1.03-.2 2.13-1.23 2.46z",
    fill: "#4caf50"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlack);
export default __webpack_public_path__ + "static/media/slack.c88946d42797aa60d55e20990a4271a4.svg";
export { ForwardRef as ReactComponent };